var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.62 14.71 3.88-3.88 3.88 3.88a.996.996 0 1 0 1.41-1.41L13.2 8.71a.996.996 0 0 0-1.41 0L7.2 13.3a.996.996 0 0 0 0 1.41c.39.38 1.03.39 1.42 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-up_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 12.25 12)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgArrowUp;